/**
 * Rules every producer of sync_jobs rows shares: the Settings "Sync" button,
 * backfill, the worker's in-app scheduler and POST /api/sync/trigger (api/_lib
 * imports this by relative path, as it does the rest of src/services).
 *
 * @module services/syncJobShared
 */

/**
 * What asked for a job. Mirrors the sync_jobs_source_vocabulary CHECK in
 * migration 103, and syncJobShared.test.ts reads that migration to hold the two
 * lists together: a value one side lacks is a 23514, which PostgREST answers
 * with a 400 — the shape that kept the Google Sync button dead for weeks after
 * migration 080.
 */
export const SYNC_JOB_SOURCES = ['manual', 'backfill', 'schedule', 'trigger'] as const;
export type SyncJobSource = (typeof SYNC_JOB_SOURCES)[number];

/** The statuses migration 103's unique indexes count as "already waiting". */
export const ACTIVE_JOB_STATUSES = ['queued', 'running'] as const;

/**
 * Whether an insert was refused because the account already has that job
 * waiting — migration 103 allows one queued/running routine job per account and
 * one per account per backfill window. That is "already queued", not a failure.
 * Every other refusal (a CHECK, RLS) is a real error and must still surface.
 */
export const isAlreadyQueued = (error: { code?: string } | null | undefined): boolean =>
  error?.code === '23505';
